export default __webpack_public_path__ + "images/56cb0d2e1f81030c9a74d901d3ad33e7-miami_mobile.webp";